module.exports = __webpack_public_path__ + "static/media/paw.811905a8.png";